import { Box } from "@mui/material";
import RenderCell from "./RenderCell";
import Info from "components/Info";
import React from "react";

function RenderCellAwardsLimitForGroup({ params, infoText, onEdit = null }) {
    return (
        <Box display={'flex'} justifyContent={'center'} width={'stretch'}>
            <Box display={'flex'} py={1} width={'stretch'} justifyContent={'center'}>
                <RenderCell params={params} saveEdit={onEdit} />
            </Box>
            {
                infoText
                &&
                <Box width={'stretch'}>
                    <Info>
                        {infoText}
                    </Info>
                </Box>
            }
        </Box>
    );
}

export default React.memo(RenderCellAwardsLimitForGroup);